import { HeroRoot, HeroContainer, HeroCopy, Header, Subheader, ImageBackground } from './Hero.styles'
import { Button } from 'components/Button'
import { useTranslation } from 'hooks/useTranslation'
import Image from 'next/image'
import banner from '../../../../../public/assets/home/temporary-hero.webp'
import Link from 'next/link'

export const Hero = () => {
    const { t } = useTranslation()
    return (
        <HeroRoot>
            <HeroContainer>
                <ImageBackground>
                    <Image priority={true} layout='fill' objectFit='cover' src={banner} alt={t('home:hero.image')} />
                </ImageBackground>
                <HeroCopy>
                    <Header>{t('home:hero.title')}</Header>
                    <Subheader as="p">{t('home:hero.subtitle')}</Subheader>
                    <Link passHref href='/meal-plan'>
                        <Button className='cta'>{t('home:CTA')}</Button>
                    </Link>
                </HeroCopy>
            </HeroContainer>
        </HeroRoot>
    )
}
